export default __webpack_public_path__ + "static/media/google_images.011f82bc.png";